module.exports = __webpack_public_path__ + "static/media/brand-refresh-AppDownload-new.ad83903c.svg";